import React, { useState, useEffect, useMemo } from "react";
import DevDataService from "../services/DevService";
import { useSelector } from 'react-redux';
import BeautifulTable from "../../components/BeautifulTable";
import { fNumber } from "../../utils/formatNumber";

const DevUser = (props) => {
  const [dev, setDev] = useState([]);

  const { user: currentUser } = useSelector((state) => state.auth);
  const currentUserId = currentUser?.id;

  useEffect(() => {
    retrieveDev();
  }, []); // eslint-disable-line

  const retrieveDev = () => {
    if (!currentUserId) return;
    DevDataService.getAll(currentUserId)
      .then((response) => {
        setDev(response.data ?? response);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const columns = useMemo(
    () => [
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => (value ? new Date(value).toLocaleDateString() : "")
      },
      { Header: "Amount", accessor: "amount", Cell: ({ value }) => (value != null && value !== "" ? fNumber(value) : "0.00") },
      {
        Header: "Transaction type",
        accessor: "creditOrDebit"
      },
      {
        Header: "Description",
        accessor: "description"
      },
      { Header: "New Balance", accessor: "newBalance", Cell: ({ value }) => (value != null && value !== "" ? fNumber(value) : "0.00") },
      {
        Header: "Posted Date",
        accessor: "createdAt",
        Cell: ({ value }) => (value ? new Date(value).toLocaleString() : "")
      }
    ],
    []
  );

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <BeautifulTable
          columns={columns}
          data={dev}
          pageSize={10}
          onRowClick={(row) => props.history?.push && props.history.push(`/dashboard/dev/${row.id || row._id}`)}
          /* no row action buttons (view/edit/delete) */
        />
      </div>
    </div>
  );
};

export default DevUser;
